// extracted by mini-css-extract-plugin
module.exports = {"modalheader":"QQModal_modalheader__alFY4","borderTop":"QQModal_borderTop__3__yX","bottomRounded":"QQModal_bottomRounded__1y7wg"};